<template>
	<Card>
		<APIList :provider="provider" :columns="columns" :disabledPredicate="isDisabled">
			<template v-slot="{ _id }">
				<Action title="Edit" @click="edit(_id)">
					<IconEdit />
				</Action>
			</template>
			<template v-slot:empty>
				<p>No competitions yet. <router-link :to="createCompPage">Create one here</router-link>.</p>
			</template>
		</APIList>
	</Card>
</template>

<script>
import Card from '@/components/Card'
import APIList from '@/components/APIList'
import Action from '@/components/Action'
import IconEdit from 'mdi-vue/Pencil'
import { EventProvider } from '@/lib/dataProvider'

export default {
	name: 'ManageCompetitions',
	data() {
		return {
			provider: EventProvider,
			columns: [
				{ label: 'Name', field: 'name' },
				{ label: 'Start', field: 'dates.from', collapse: true },
				{ label: 'End', field: 'dates.to', collapse: true },
				{ label: 'Created', field: 'createdAt' },
			],
			createCompPage: {
				name: 'Create Competition',
			},
		}
	},
	methods: {
		edit(_id) {
			this.$router.push({
				name: 'Edit Competition',
				params: {
					id: _id,
				},
			})
		},
		isDisabled(resource) {
			return !resource.enabled
		},
	},
	components: {
		Card,
		APIList,
		Action,
		IconEdit,
	},
}
</script>
